var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-mail-green';
                    var viewUrl = 'gfx/sprite.svg#view-icon-mail-green';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 30 29',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };